import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/its/services/authentication.service';
import { AuthorityService } from '../services/authority.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private authorityService: AuthorityService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
        const user = this.authenticationService.getUserValue;
        const isLoggedIn = user?.token;
        const uo = this.authorityService.getEnteUOValue;
        const isLoggedUOIn = uo?.codeUO;
        const isApiUrl = request.url.startsWith(environment.apiUrl);
        if (isLoggedIn && isApiUrl && isLoggedUOIn) {
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${user.token}`,
                              'ITS-IDUser':`${user.userName}`,
                              'ITS-IDClient':`FPND957AK`,
                              'ITS-IDAuthority':`${uo.codeUO}`
                            }
            });
        }
        else if (isLoggedIn && isApiUrl){
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${user.token}`,
                              'ITS-IDUser':`${user.userName}`,
                              'ITS-IDClient':`FPND957AK`,
                            }
            });
        }


        return next.handle(request);
    }
}